import { useState } from "react";
import { buscarLeadsByIdService } from "../../../services/buscarLeadsByIdService";
import { atualizarCompatibilidade } from "../../../services/atualizarCompatibilidadeService";

export const useAtualizarCompatibilidade = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const atualizar = async (
    idCompatibilidade: number,
    compatibilidadeData: any
  ) => {
    setIsLoading(true);
    try {
      const atualizarDados = await atualizarCompatibilidade(
        idCompatibilidade,
        compatibilidadeData
      );

      if (atualizarDados) {
        setSuccess("Interesse atualizado com sucesso");
      } else {
        setError(
          "Não foi possível atualizar interesse, por favor tente novamente!"
        );
      }
    } catch (error) {
      console.error("Erro ao buscar lead:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { atualizar, isLoading, error, success, resetError, resetSuccess };
};
